import request from '@/utils/request'

//学生端-banner图列表
export function bannerList(data) {
	return request({
		url: '/api/banner/bannerListStudent',
		method: 'get',
		params: data
	})
}